import { render, staticRenderFns } from "./CoverDetailsPage.vue?vue&type=template&id=c5a729d2&scoped=true&"
import script from "./CoverDetailsPage.vue?vue&type=script&lang=js&"
export * from "./CoverDetailsPage.vue?vue&type=script&lang=js&"
import style0 from "./CoverDetailsPage.vue?vue&type=style&index=0&id=c5a729d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a729d2",
  null
  
)

export default component.exports